import { styled as o } from "@lokalise/styled";
import { spacing as r, value as e, typography as t } from "../../utils/theme/index.js";
import { outlineStyle as a } from "../../utils/styles/outlineStyle.js";
const d = o.div`
	position: relative;
	display: grid;
	grid-auto-flow: row;
	gap: ${r(1)};
	width: 100%;
`, l = o.input`
	/* First we set colors */

	/* Unchecked */
	--accent: ${e("color.border.input.default")};
	--backdrop: ${e("color.background.transparent")};

	/* Checked or Indeterminate */
	&:checked,
	&:indeterminate {
		--accent: ${e("color.background.action.primary.default")};
		--backdrop: ${e("color.text.inverse")};
	}

	/* Hover */
	&:hover {
		--accent: ${e("color.background.action.primary.hover")};
	}

	/* Pressed */
	&:active {
		--accent: ${e("color.background.action.primary.hover")};
	}

	/* Error */
	&[aria-invalid='true'] {
		--accent: ${e("color.background.action.danger.default")};

		&:checked,
		&:indeterminate {
			--backdrop: ${e("color.text.inverse")};
			--accent: ${e("color.background.action.danger.default")};
		}
	}

	/* Disabled */
	&:disabled {
		--accent: ${e("color.border.disabled")};
		--backdrop: ${e("color.background.disabled")};

		&:checked,
		&:indeterminate {
			--accent: ${e("color.background.disabled")};
			--backdrop: ${e("color.text.inverse")};
		}
	}

	/* Create a custom checkbox and hide the browser's default checkbox */

	/* Unchecked */
	display: inline-block;
	appearance: none;
	margin: 0;
	height: 14px;
	width: 14px;
	box-sizing: border-box;
	border: 1px solid var(--accent);
	background-color: var(--backdrop);
	border-radius: ${e("radius.s")};
	transition:
		background-color ${e("motion.speed.1")},
		border ${e("motion.speed.1")};

	/* Checked  */
	/* ':where' causes this selector not to gain specificity and allows other styles to override it. Without it it had more specificity than '&[aria-invalid='true']' */
	&:checked:where(:not(:indeterminate)) {
		background-color: var(--accent);

		&:after {
			content: '';
			box-sizing: border-box;
			display: block;
			width: 4px;
			height: 7px;
			border: solid var(--backdrop);
			border-width: 0 1px 1px 0;
			transform: translate(4px, 1.5px) rotate(45deg);
		}
	}

	/* Indeterminate  */
	&:indeterminate {
		background-color: var(--accent);

		&:after {
			content: '';
			box-sizing: border-box;
			display: block;
			border: solid var(--backdrop);
			border-width: 1px 0 0 0;
			width: 6px;
			height: 1px;
			transform: translate(3px, 5.5px);
		}
	}

	/* Focus outline is only visible when user is using keyboard. This behavior matches native checkbox behavior */
	&:focus-visible {
		${a}
	}
`, s = o.label`
	display: grid;
	grid-template-columns: min-content;
	grid-auto-flow: column;
	gap: ${r(2)};
	align-items: center;
	font-family: ${e("font.family.default")};
	margin: 0;

	&:has(input:disabled),
	&:has(input:disabled) * {
		cursor: not-allowed;
	}
`, b = o.span`
	${t("body.small.default")};
	color: ${e("color.text.default")};
	cursor: default;
`, p = o.div`
	width: 100%;
`, u = o.div`
	display: grid;
	gap: ${r(3)};
`, h = o.div`
	padding-top: ${r(3)};
`;
export {
  l as CheckboxInput,
  d as Container,
  s as Label,
  u as MultiCheckbox,
  p as MultiCheckboxContainer,
  h as MultiCheckboxErrorContainer,
  b as Text
};
//# sourceMappingURL=Checkbox.styles.js.map
